{
    "update_password": {
        "title": "Update password",
        "success": "Password updated successfully !",
        "current_password": "Actual password",
        "new_password": "Choose a new password",
        "confirm_password": "Confirm new password",
        "passwords_mismatch": "Passwords do not match.",
        "passwords_match": "Passwords are identical."
    },
    "mfa": {
        "application": "Download the Google Authenticator application or another authentication application to your mobile device:",
        "attempts_info_init_plural": "You have {{attempts}} attempts left",
        "attempts_info_init_singular": "You have {{attempts}} attempt left",
        "cancel_message": "You can activate two-factor authentication in the portal from your user account at any time.",
        "cgu": {
            "title": "Terms of Service",
            "sub_title": "The present terms of Service apply to all users of the site ",
            "articles": {
                "1": {
                    "title": "Article 1: Legal notice",
                    "content": [
                        {
                            "type": "highlight",
                            "label": "Company name: ",
                            "text": "{{rootOrganization.legalName}}"
                        },
                        {
                            "type": "text",
                            "text": "Head office: {{rootOrganization.address}}"
                        },
                        {
                            "type": "text",
                            "text": "SIRET : {{rootOrganization.registrationNumber}}",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "Publisher : PRELUDD PAYMENT SERVICES"
                        },
                        {
                            "type": "text",
                            "text": "Head office: 3 boulevard Henri Ziegler, 31700 BLAGNAC, France"
                        },
                        {
                            "type": "textLink",
                            "label": "Email : ",
                            "text": "support@preludd.com",
                            "href": "mailto:support@preludd.com"
                        },
                        {
                            "type": "text",
                            "text": "SIRET : 82304150400015 (RCS de TOULOUSE)"
                        },
                        {
                            "type": "text",
                            "text": "Intracommunity VAT number: FR00823041504"
                        },
                        {
                            "type": "text",
                            "text": "Share capital: 56 250,40 €",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "Host: PRELUDD PAYMENT SERVICES"
                        },
                        {
                            "type": "text",
                            "text": "Head office: 3 boulevard Henri Ziegler, 31700 BLAGNAC, France"
                        },
                        {
                            "type": "textLink",
                            "label": "Email : ",
                            "text": "support@preludd.com",
                            "href": "mailto:support@preludd.com"
                        }
                    ]
                },
                "2": {
                    "title": "Article 2 : Functionnalities",
                    "content": [
                        {
                            "type": "link",
                            "text": "The Monetist portal is accessible via the following link ",
                            "label": "{{getPortalAddress()}}",
                            "href": "https://{{getPortalAddress()}}",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "The Monetist will be able to activate multi-factor authentication."
                        }
                    ]
                },
                "3": {
                    "title": "Article 3 : Terms of Use",
                    "content": [
                        {
                            "type": "text",
                            "text": "This multi-factor authentication is based on two factors, the knowledge factor which corresponds to the login provided as well as the information of a password. Then through a second factor which corresponds to that of possession, which means that the User will have to install an authentication application."
                        }
                    ]
                },
                "4": {
                    "title": "Article 4 : Modifications and evolutions",
                    "content": [
                        {
                            "type": "text",
                            "text": "In case of major modifications or evolutions of this functionality, these will appear in a window on the homepage of the site.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "The Monetist is deemed to accept all modifications or evolutions of this functionality, in the absence of contesting within 15 days from the information of the modification or evolution.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "To contest, the Monetist must contact the support service.",
                            "separator": true
                        }
                    ]
                },
                "5": {
                    "title": "Article 5 : Processing of personal data",
                    "content": [
                        {
                            "type": "text",
                            "text": "All the necessary measures allowing to guarantee the safety and the confidentiality of the information and the personal data, are taken by the editor.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "The information transmitted by the User remains under the control of the latter and must respect the laws and regulations in force. He can modify or delete them at any time."
                        }
                    ]
                },
                "6": {
                    "title": "Article 6 : Commitment and responsibility",
                    "content": [
                        {
                            "type": "text",
                            "text": "The Monetist is held as responsible for the data that belongs to him within this functionality.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "The Monetist undertakes to preserve the confidentiality of the information.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "The Monetist undertakes to respect all applicable laws, rules and regulations as well as technical standards applicable to the functionality.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "The publisher of the site is held to an obligation of means to provide the service, being dependent on the various network operators, it cannot be held responsible for the inaccessibility of the site, except in the case of an imputable failure.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "The responsibility of the editor cannot be engaged in case of a use of the functionality following a disclosure, a loss or a theft of the access codes or the data, as well as in case of non-conforming use of the functionality.",
                            "separator": true
                        }
                    ]
                },
                "7": {
                    "title": "Article 7 : Intellectual property",
                    "content": [
                        {
                            "type": "text",
                            "text": "The editor declares to have all the rights and authorizations allowing the Monetist to use the service and in return the User recognizes that the site is not of his property."
                        }
                    ]
                }
            }
        },
        "cgu_title": "Please read and accept the terms of use before continuing:",
        "code_validation": "Enter the code provided by your application:",
        "confirm_activation_message": "Do you want to activate the two-factor authentication to secure the portal ?",
        "confirm_deactivation_message": "The two-factor authentication is already activated for this account, do you want to deactivate it ?",
        "deactivation_title": "Disabling two-factor authentication",
        "deactivation_ongoing": "Disabling two-factor authentication in progress",
        "deactivation_success": "Two-factor authentication has been successfully disabled",
        "deactivation_error": "An error has occurred. Two-factor authentication could not be disabled",
        "fetch_error": "An unexpected error occurred. If it occurs again, please contact the technical support.",
        "init_success": "L'authentification à double facteur est activée",
        "init_error": "Failed to activate two-factor authentication",
        "init_title": "Two-factor authentication",
        "modal_title": "Activating two-factor authentication",
        "qrcode": "Read this QRcode with your application to synchronise it:",
        "remove_modal_title": "Deactivating two-factor authentication",
        "remove_text_validation": "Are you sure you want to deactivate two-factor authentication?",
        "remove_email_information": "If yes, the deactivation link will be sent to your mail:",
        "remove_email_warning": "The email is sent. If it is not in inbox, please check your spam folder",
        "remove_email_missing": "Missing email",
        "remove_send_email_error": "An error has occurred"
    },
    "modal": {
        "reload_page": {
            "title": "Update available",
            "text": "A new version of the portal is available.",
            "text2": "The page will <1>automatically refresh in 5 minutes.</1>",
            "text3": "You can also <1>apply the update immediately</1> by clicking on <1>Update now.</1>",
            "auto_refresh": "Update now"
        }
    },
    "toast": {
        "reload_page": {
            "message": "Update in 1 minute"
        }
    }
}